import PopupBase from './PopupBase';
import { useState } from 'react';
import UserApi from '../api/UserApi';

const UserRegisterPop = ({ close, userData }) => {
    const [form, setForm] = useState(userData ||{
        USER_ID: '',
        USER_PW: '',
        USER_TYPE: '002',
        USER_MEMO: '',
        USER_ORG: ''
    });

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    }

    const handleConfirm = () => {
        if (userData) {
            UserApi.updateUser(userData.USER_ID, form).then(rslt => {
                console.log(rslt);
                close(true);
            });
        } else {
            UserApi.createUser(form).then(rslt => {
                console.log(rslt);
                close(true);
            });
        }
    }

    return (
        <PopupBase title="사용자 등록" confirmText={userData ? '수정' : '등록'} cancelText="취소" confirm={handleConfirm} close={close}>    
            <div className="modal-body">
                <div className="form-field">
                    <label className="field-lable">아이디</label>
                    <div className="field-input">
                        <span className="field-required">*</span>
                        <input type="text" name="USER_ID" readOnly={!!userData} placeholder="아이디를 입력해주세요." required="" value={form.USER_ID} onChange={handleChange} />
                    </div>      
                </div>
                <div className="form-field">
                    <label className="field-lable">비밀번호</label>
                    <div className="field-input">
                        <span className="field-required">*</span>
                        <input type="text" name="USER_PW" placeholder="비밀번호를 입력해주세요." required="" value={form.USER_PW} onChange={handleChange} />
                    </div>      
                </div>  
                <div className="form-field">
                    <label className="field-lable">권한</label>
                    <div className="field-input">
                        <span className="field-required">*</span>
                        <input type="text" name="USER_TYPE" placeholder="권한을 입력해주세요." readOnly value="일반" />
                    </div>          
                </div>
                <div className="form-field">
                    <label className="field-lable">회사명</label>
                    <div className="field-input">
                        <input type="text" name="USER_ORG" placeholder="회사명을 입력해주세요." value={form.USER_ORG} onChange={handleChange} />
                    </div>      
                </div>
                <div className="form-field">
                    <label className="field-lable">메모</label>
                    <div className="field-input">
                        <textarea name="USER_MEMO" placeholder="메모를 입력해주세요." value={form.USER_MEMO}  onChange={handleChange}></textarea>
                    </div>
                </div>
            </div>
        </PopupBase>
    )
}

export default UserRegisterPop;